import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link } from 'react-router-dom';

import { api_crud_route, api_list_route, api_list_route2, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../Utils';
import { getTokenInfo } from './../../../UseToken';
export default function List() {



    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    useEffect(() => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res =>
                reqGET(api_list_route2(getTokenInfo().companycode))
                    .then(res2 => { setData(res.data.concat(res2.data)); setLoading(false) })
                    .catch(() => 404




                    )
            )
    }, []);


    //APAGAR REGISTO
    function apagar(id) {
        if (window.confirm('Tem a certeza que quer apagar esta Entidade?')) {


            reqDELETE(api_crud_route, { id: id })
                .then(() => {
                    setLoading(true);
                    alert('Registo Apagado com Sucesso');
                })
                .catch(e => alert('Problema ao Apagar Registo'))
        }
    }

    const columns = [
        {
            name: 'Nome',
            selector: 'name',
            cell: row => <div>{row.name}</div>,
            width: '200px',
            sortable: true,
            let: true,
        },

        {
            name: 'Tipo',
            selector: 'profile',
            sortable: true,
            left: true,
        },
        {
            name: 'Estado',
            selector: 'ativo',
            cell: row => <div>{row.ativo === "true" ? 'Ativo' : 'Inativo'}</div>, 
            sortable: true,
            center: true,
        },
        {
            name: 'NIF',
            selector: 'vat',
            sortable: true,
            left: true,
        },
        {
            name: 'Telemóvel',
            selector: 'mobile_phone',
            sortable: true,
            left: true,
        },
        {
            name: 'E-mail',
            selector: 'email',
            sortable: true,
            left: true,

            //cellExport: row => ({ Title: 'asdasd', Example: 'oi' }),
        },
        {
            name: '',
            right: true,

            export: false,
            //print: false,

            cell: row =>

                <span>

                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <img alt='visualizar' src={'./img/view.svg'} />
                    </Link>

                    {/*style={{ display: 'none' }}*/}
                    <Link className="button button-update" to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                        <img alt='editar' src={'./img/editar.svg'} />
                    </Link>


                    <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                        <img alt='apagar' src={'./img/eliminar.svg'} />
                    </button>
                </span >

        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: 'Registos por página:',
        rangeSeparatorText: 'de',
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
    };


    const tableData = {
        columns,
        data,
        filterPlaceholder: 'Procurar'
    };


    return (isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">LOADING</h2>
                <p>LOADING</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>

            </div>
        </main>

        :

        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">Colaboradores</h2>
                <p>Home / Colaboradores / Lista de Colaboradores</p>
            </div>

            <div className={`dash-cards-2 body`}>
                <div className="card">
                    <div className="div-table">
                        <div className="table-body">
                            <DataTableExtensions {...tableData}>

                                <DataTable
                                    noDataComponent='Sem Registos'
                                    noHeader
                                    pagination
                                    exportHeaders
                                    paginationComponentOptions={defaultComponentOptions}
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                />
                            </DataTableExtensions>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}